import type {
  HotelUpSellFailedProperties,
  TappedHotelUpSellModalCtaProperties,
  UpSellCommonProperties,
  ViewedHotelUpSellProperties,
} from "../raw/UpSellRawEvent";

export enum RbcUpSellEventName {
  viewed_hotel_up_sell = "viewed_hotel_up_sell",
  tapped_hotel_up_sell = "tapped_hotel_up_sell",
  viewed_hotel_up_sell_modal = "viewed_hotel_up_sell_modal",
  tapped_hotel_up_sell_modal_cta = "tapped_hotel_up_sell_modal_cta",
  hotel_up_sell_failed = "hotel_up_sell_failed",
}

export interface ViewedHotelUpSellEvent {
  name: RbcUpSellEventName.viewed_hotel_up_sell;
  properties: ViewedHotelUpSellProperties;
}

export interface TappedHotelUpSellEvent {
  name: RbcUpSellEventName.tapped_hotel_up_sell;
  properties: UpSellCommonProperties;
}

export interface ViewedHotelUpSellModalEvent {
  name: RbcUpSellEventName.viewed_hotel_up_sell_modal;
  properties: UpSellCommonProperties;
}

export interface TappedHotelUpSellModalCtaEvent {
  name: RbcUpSellEventName.tapped_hotel_up_sell_modal_cta;
  properties: TappedHotelUpSellModalCtaProperties;
}

export interface HotelUpSellFailedEvent {
  name: RbcUpSellEventName.hotel_up_sell_failed;
  properties: HotelUpSellFailedProperties;
}

export type UpSellEvent =
  | ViewedHotelUpSellEvent
  | TappedHotelUpSellEvent
  | ViewedHotelUpSellModalEvent
  | TappedHotelUpSellModalCtaEvent
  | HotelUpSellFailedEvent;
